import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '../components/ui/table'
import { ScrollArea } from './ui/scroll-area'
import { UsersFormData } from '../validators/users-validator'
import { DialogEditUser } from '../modals/modal-edit-user'
import { useState } from 'react'
import { Trash2, UserPen } from 'lucide-react'
import { DialogDelete } from '../modals/modal-delete'
import { Endpoints } from '@/remote/endpoints'
import { useLocalStorage } from '@/remote/local-storage'
import { useToast } from '../hooks'

type TableUsersProps = {
  data: UsersFormData[],
  height?: string,
  getRefreshList?: () => void
}

export function TableUser({ data, height, getRefreshList }: TableUsersProps) {

  const [dataId, setDataId] = useState(0)
  const { getName } = useLocalStorage()
    const { showToast } = useToast();
  const [dialogEdit, setDialogEdit] = useState(false)
  const [dialogDelete, setDialogDelete] = useState(false)

  const openDialogEdit = (id: number) => {
    setDataId(id)
    setDialogEdit(true)
  }

  const closeDialogEdit = () => {
    setDialogEdit(false)
  }


  const openDialogDelete = (id: number) => {
    setDataId(id)
    setDialogDelete(true)
  }

  const closeDialogDelete = () => {
    setDialogDelete(false)
  }

  return (
    <div className={'overflow-y-auto' + height}>
      {dialogEdit && <DialogEditUser id={dataId} closeDialog={closeDialogEdit} isOpen={dialogEdit} updateList={getRefreshList} />}
      {dialogDelete && (
        <DialogDelete
          updateList={getRefreshList}
          closeDialog={closeDialogDelete}
          id={dataId}
          isOpen={dialogDelete}
          url={Endpoints.users}
          label='Usuário'
        />
      )}
      <ScrollArea className="m-4 h-container-members-list relative">
        <Table className='border-none'>
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead>
              <TableHead>Nome</TableHead>
              <TableHead>Descrição</TableHead>
              <TableHead>Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((user: UsersFormData, position: number) => (
              <TableRow key={position} className='text-gray-600'>
                <TableCell>{user?.id || 'Sem Id'}</TableCell>
                <TableCell
                  className='flex gap-2 capitalize cursor-pointer text-acelerafit-gray-dark hover:text-cashfit-green-200'
                >
                  {user.nome}
                </TableCell>
                <TableCell>{user?.email}</TableCell>
                <TableCell className='flex'>
                  <UserPen
                    onClick={() => openDialogEdit(user?.id || 0)}
                    height={24}
                    width={30}
                    className='text-blue-500 cursor-pointer p-1  hover:text-blue-400' />
                  <Trash2
                    onClick={user.nome === getName() ? () => {showToast('Você não pode excluir seu próprio usuário', 'error')} : () => openDialogDelete(user?.id || 0)}
                    height={24}
                    width={30}
                    className={user.nome === getName() ? 'text-gray-400 cursor-not-allowed p-1' : 'text-red-500 cursor-pointer p-1 hover:text-red-400'}
            
                  />
                </TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ScrollArea>
    </div>
  )
}